import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ConfigurationItem, ConfigurationValue } from '../../_objects/tenant-config';
import { TenantConfigSchema } from '../../_offline/models/tenantConfiguration.schema';
import { TenantConfigurationDbService } from '../database/tenant-configuration-db.service';
import { TenantConfigContractService } from '../interfaces/tenant-config-contract.service';
import { LoginUserOfflineService } from './login-user-offline.service';
import { TenantDetail } from '../../_objects/offline-management';
import { TenantDetailDbService } from '../database/tenant-detail-db.service';

@Injectable({
  providedIn: 'root'
})
export class TenantConfigOfflineService implements TenantConfigContractService {

  constructor(
    private tenantConfigDbService: TenantConfigurationDbService,
    private tenantDetailsDbServie: TenantDetailDbService,
    private logionUserService: LoginUserOfflineService
  ) { }

  getTenantDetails(): Observable<TenantDetail> {
    return this.tenantDetailsDbServie.get()
      .pipe(
        filter(schema => !!schema),
        map(schema => ({ id: schema.id, name: schema.name })));
  }

  getTenantConfigs(): Observable<ConfigurationItem[]> {
    return this.tenantConfigDbService.getAll()
      .pipe(map(configSchemas => configSchemas.map(configSchema => this.configItemParseToSchema(configSchema))));
  }
  putTenantConfigs(configs: ConfigurationItem[]): Observable<ConfigurationItem[]> {
    const configSchemas = configs
      .map(value => new TenantConfigSchema(this.logionUserService.tenantId, value));

    return this.tenantConfigDbService.putAll(configSchemas)
      .pipe(map(schemas => schemas.map(configSchema => this.configItemParseToSchema(configSchema))));
  }

  private configItemParseToSchema(schema: TenantConfigSchema) {

    let value: ConfigurationValue;
    switch (schema.valueType) {
      case 'string':
        value = schema.value;
        break;
      case 'boolean':
        value = (schema.value === 'true');
        break;
      case 'number':
        value = parseInt(schema.value, 10);
        break;
    }

    return new ConfigurationItem(schema.key, value, schema.groupKey, JSON.parse(schema.selectItems));
  }
}
